import Cash from '../components/components/Cash';
import CreditCard from '../components/components/CreditCard';
import Pinpad from '../components/components/Pinpad';
import Echeck from '../components/components/Echeck';
import Check from '../components/components/Check';

const methodsMap = {
  CASH: Cash,
  CREDIT_CARD: CreditCard,
  PINPAD: Pinpad,
  ECHECK: Echeck,
  CHECK: Check,
};

export default methodsMap;
